<div *ngIf="data.personaFisica" class="flex justify-between header">
  <div *ngIf="formVisible" style="height: 48px;" class="flex items-center">
    <button mat-icon-button color="primary" aria-label="Indietro" matTooltip="Indietro" (click)="back()">
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
  </div>
  <h2 *ngIf="!formVisible" color="primary">Lista immobili</h2>
  <button *ngIf="!formVisible" mat-icon-button mat-dialog-close aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
  <h2 *ngIf="formVisible" color="primary">{{currentId ? 'Modifica immobile' : 'Aggiungi immobile'}}</h2>

</div>

<div *ngIf="data.personaGiuridica" class="flex justify-between header">
  <h2>{{data.property ? 'Modifica immobile' : 'Aggiungi immobile'}}</h2>
  <button mat-icon-button mat-dialog-close aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="primary-bg header min-height">
  <h2>{{name}}</h2>
  <p class="small light">{{role}}</p>
</div>

<mat-dialog-content [class.mat-elevation-z2]="formVisible" [class.no-actions-dialog-content]="!formVisible"
  class="double-header-dialog-content">

  <div *ngIf="!formVisible">
    <app-property-table [properties]="properties" (selectedProperty)="onPropertyEdit($event)"
      (onDeleteProperty)="onDeleteProperty($event)"></app-property-table>
    <div class="margin-top-rounded-buttons">
      <button mat-flat-button color="accent" class="squared-button" aria-label="Aggiungi nuovo immobile"
        matTooltip="Aggiungi nuovo immobile" [disabled]="praticaProgressService.isFrozenOrConfermata"
        (click)="onAddElement()">
        +
      </button>
    </div>
  </div>

  <div *ngIf="formVisible">
    <smart-form [fields]="fields"></smart-form>

  </div>



</mat-dialog-content>
<mat-dialog-actions *ngIf="formVisible" align="center">
  <button mat-flat-button class="big" color="accent" (click)="save()">{{currentId ?
    'Modifica' :
    'Salva'}}</button>
</mat-dialog-actions>